import React from 'react';
import PropTypes from 'prop-types';

const TextSnippet = ({ snippet_title, snippet_text  }) => (
  <div className="template__text-snippet">

      <div
        className="template__text-snippet-title"
        dangerouslySetInnerHTML={{
          __html: snippet_title.html,
        }}
      />

      <div
        className="template__text-snippet-text"
        dangerouslySetInnerHTML={{
          __html: snippet_text.html,
        }}
      />
  </div>
);

TextSnippet.defaultProps = {

};

TextSnippet.propTypes = {
  /** Docgen prop description */
};

export default TextSnippet;

export const query = graphql`
  fragment TextSnippetFragment on PrismicCaseStudyBodyTextSnippet {
    slice_type
    primary {
      snippet_text {
        html
      }
      snippet_title {
        html
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/CaseStudy/TextSnippet/TextSnippet.js